import React, { type Ref } from 'react';

import Button from '@atlaskit/button/default/button';
import { FullScreenModalTrigger } from '@atlassian/entry-points/full-screen-modal-trigger';
import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';

import { modalEntryPoint } from '../fixtures/modal-entry-point';
import { RelayWrapper } from '../utils/wrapper';

export default function FullScreenModalTriggerExample(): React.JSX.Element {
	return (
		<RelayWrapper>
			<ModalContextProvider>
				<FullScreenModalTrigger
					entryPoint={modalEntryPoint}
					title="Example Modal"
					loadingText="Loading example modal"
				>
					{({ ref }) => (
						<Button ref={ref as Ref<HTMLButtonElement>} aria-haspopup="dialog">
							Open full screen modal
						</Button>
					)}
				</FullScreenModalTrigger>
			</ModalContextProvider>
		</RelayWrapper>
	);
}
